import { render, staticRenderFns } from "./ContactAsset.vue?vue&type=template&id=8ef0f912"
import script from "./ContactAsset.vue?vue&type=script&lang=js"
export * from "./ContactAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports